export default __webpack_public_path__ + "static/media/deposit rate table.3c81d781.png";